/* unplugin-vue-components disabled */import script from "./MailUserInfoDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./MailUserInfoDialog.vue?vue&type=script&setup=true&lang=ts"

import "./MailUserInfoDialog.vue?vue&type=style&index=0&id=22f2e32b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f2e32b"]])

export default __exports__